import React, { Component, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { getServerUrl } from "../config";
import axios from "axios";
import { Table, Space, Breadcrumb, Input, Button, Select, Col } from "antd";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
import { CSVLink } from "react-csv";
// import ReactExport from "react-export-excel";

// const ExcelFile = ReactExport.ExcelFile;
// const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
// const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const { Option } = Select;

const VendorReport = (props) => {
  const [details, setdetails] = useState([]);
  const [searchInput, setsearchInput] = useState([""]);
  const [searchText, setsearchText] = useState([""]);
  const [searchedColumn, setsearchedColumn] = useState([""]);
  const [contractor, setcontractor] = useState([""]);
  const [contractorid, setcontractorid] = useState();
  const [data, setdata] = useState("");
  useEffect(() => {
    axios
      .get(`${getServerUrl()}/master/contractor`, {
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
      .then((res) => {
        if (res.data.data) {
          let responsevalue = Object.values(res.data.data);
          const condetails = responsevalue;
          setcontractor(condetails);
        }
      });
  }, []);
  const ContractordropDownOptions = contractor.map((dataDrop) => {
    return (
      <Option value={dataDrop.contractor_id}>{dataDrop.contractor_name}</Option>
    );
  });

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            setsearchInput(node);
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        //setTimeout(() => searchInput.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setsearchedColumn(dataIndex);
    setsearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setsearchText("");
  };

  const columns = [
    {
      title: "Contractor",
      dataIndex: "source_name",
      key: "source_name",
    },
    {
      title: "Component",
      dataIndex: "component_no",
      render: (text, record) =>
        record.component_no + "\n" + record.component_name,
    },

    {
      title: "Process Name",
      dataIndex: "processName",
      key: "processName",
    },

    {
      title: "Quantity",
      dataIndex: "destination_confirm_quantity",
      key: "destination_confirm_quantity",
    },
    {
      title: "Price",
      dataIndex: "destination_confirm_quantity",
      render: (text, record) =>
        Number(record.destination_confirm_quantity * record.rate).toFixed(2),
    },
    {
      title: "Action",
      dataIndex: "contractorid",
      key: "contractorid",
      render: (text, record) => (
        <Space size="middle">
          <NavLink
            to={
              "/stockdetail/" +
              record.source +
              "/" +
              record.component_id +
              "/" +
              record.processName
            }
          >
            View in details
          </NavLink>
        </Space>
      ),
    },
  ];

  const columnsAll = [
    // {
    //   title: "Trip Date",
    //   dataIndex: "transdate",
    //   key: "transdate",
    // },
    {
      title: "Contractor",
      dataIndex: "source_name",
      key: "source_name",
    },

    {
      title: "Component",
      dataIndex: "component_no",
      render: (text, record) =>
        record.component_no + "\n" + record.component_name,
    },

    {
      title: "Process Name",
      dataIndex: "processName",
      key: "processName",
    },

    {
      title: "Quantity",
      dataIndex: "destination_confirm_quantity",
      key: "destination_confirm_quantity",
    },
    {
      title: "Price",
      dataIndex: "destination_confirm_quantity",
      render: (text, record) =>
        Number(record.destination_confirm_quantity * record.rate).toFixed(2),
    },
    {
      title: "Action",
      dataIndex: "contractorid",
      key: "contractorid",
      render: (text, record) => (
        <Space size="middle">
          <NavLink
            to={
              "/stockdetail/" +
              record.source +
              "/" +
              record.component_id +
              "/" +
              record.processName
            }
          >
            View in details
          </NavLink>
        </Space>
      ),
    },
  ];

  function ContractorChange(value) {
    axios
      .get(
        `${getServerUrl()}/transcation/getcompletedtripbycontractor/${value}/${localStorage.getItem(
          "fromDateUnix"
        )}/${localStorage.getItem("toDateUnix")}`,
        {
          headers: { "x-auth-token": localStorage.getItem("token") },
        }
      )
      .then((res) => {
        let responsevalue = res.data.data;
        const datadetails = responsevalue;
        setdetails(datadetails);
      });
    setcontractorid(value);
  }
  var s = new Date(
    localStorage.getItem("fromDateUnix") * 1000
  ).toLocaleDateString("en-US");
  var e = new Date(
    localStorage.getItem("toDateUnix") * 1000
  ).toLocaleDateString("en-US");
  const TableHeaders = [
    { label: "Component ID & Component Name", key: "componentName" },
    { label: "Process", key: "processName" },
    {
      label: "Quantity",
      key: "destination_confirm_quantity",
    },
    { label: "PO Rate", key: "rate" },
    { label: "Total Price", key: "rate" },
  ];
  return (
    <div>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Report </Breadcrumb.Item>
        <Breadcrumb.Item>Contractor Report</Breadcrumb.Item>
      </Breadcrumb>
      <div
        className="site-layout-background"
        style={{ padding: 24, minHeight: 360 }}
      >
        <h2 className="titles">Contractor Report</h2>
        <br></br>
        <Select
          onChange={ContractorChange}
          placeholder="Please Select Type"
          style={{ width: "250px" }}
        >
          <Option value="">Please Choose</Option>
          <Option value="All">All Vendors</Option>
          {ContractordropDownOptions}
        </Select>
        <br></br> <br></br>
        <Space></Space>
        <br />
        {contractorid && contractorid != "All" && details.length > 0
          ? "Contractor Name : " + details[0].source_name
          : ""}
        <br />
        <br />
        {details.length > 0 ? (
          <NavLink to={"/contractor-report-export/" + contractorid}>
            {" "}
            Print Report{" "}
          </NavLink>
        ) : (
          " "
        )}
        {/* {details.length > 0 ? (
          <ExcelFile
            filename={
              "Contractor Report " + details[0].source_name + "-" + s + "-" + e
            }
            element={
              <Button type="primary" shape="round" size="large">
                Download Data
              </Button>
            }
          >
            <ExcelSheet
              data={details}
              name={"Contractor Report " + details[0].source_name}
            >
              <ExcelColumn
                label="Component ID & Component Name"
                value={(col) => col.component_no + "-" + col.component_name}
              />

              <ExcelColumn label="Process" value="processName" />
              <ExcelColumn
                label="Quantity"
                value="destination_confirm_quantity"
              />
              <ExcelColumn label="PO Rate" value="rate" />
              <ExcelColumn
                label="Quantity"
                value={(col) =>
                  Number(col.destination_confirm_quantity) * Number(col.rate)
                }
              />
            </ExcelSheet>
          </ExcelFile>
        ) : (
          ""
        )} */}
        <br></br>
        <br />
        {contractorid ? (
          <Table
            scroll={{ x: 1300 }}
            columns={contractorid === "All" ? columnsAll : columns}
            dataSource={details}
          ></Table>
        ) : (
          "        "
        )}{" "}
      </div>
    </div>
  );
};

export default VendorReport;
